export default __webpack_public_path__ + "static/media/glassmorphism.247a01fa.PNG";